var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{attrs:{"sm":24}},[_c('el-result',{attrs:{"icon":_vm.icon,"title":"警告提示"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"fts-20"},[_vm._v("您的申请已提交,请耐心等待")])]),_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.goList}},[_vm._v("返回列表")])],1)],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }